var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconCheck, IconMinus } from "@tabler/icons-react";
import { COLLECT_TRANSACTION_LABELS, COLLECT_VALIDATION_EMPTY_CODE_LABEL, COLLECT_VALIDATION_MISSING_POLICIES_LABEL, COLLECT_VALIDATION_TABLE_ACTION_DETAIL_LABEL, COLLECT_VALIDATION_TABLE_ACTION_LABEL, COLLECT_VALIDATION_TABLE_CODE_LABEL, COLLECT_VALIDATION_TABLE_DESCRIPTION_LABEL, COLLECT_VALIDATION_TABLE_IN_CATALOG_LABEL, COLLECT_VALIDATION_TABLE_LABEL_LABEL, COLLECT_VALIDATION_TABLE_POLICIES_LABEL, COLLECT_VALIDATION_TABLE_ROWS_LABEL, COLLECT_VALIDATION_TABLE_TRANSACTION_LABEL, COLLECT_VALIDATION_TOTAL_POLICIES_LABEL, COLLECT_VALIDATION_TOTAL_ROWS_LABEL, COLLECT_VALIDATION_UNKNOWN_ROWS_LABEL, getCollectTransactionLabel, } from "../../../constants/collect.constants";
var getTransactionTone = function (transaction) {
    if (transaction === COLLECT_TRANSACTION_LABELS.DEBIT)
        return "info";
    if (transaction === COLLECT_TRANSACTION_LABELS.REJECTED)
        return "negative";
    if (transaction === COLLECT_TRANSACTION_LABELS.CANCELLED)
        return "neutral";
    return "neutral";
};
var buildCodeColumns = function (showCodeColumn) { return __spreadArray(__spreadArray([], (showCodeColumn
    ? [
        {
            key: "code",
            header: COLLECT_VALIDATION_TABLE_CODE_LABEL,
            width: "110px",
            render: function (row) {
                return row.values.code ? (_jsx("span", __assign({ style: { whiteSpace: "normal", wordBreak: "break-word" } }, { children: row.values.code }))) : (_jsx("span", __assign({ style: {
                        fontStyle: "italic",
                        color: "var(--mantine-color-gray-6)",
                    } }, { children: COLLECT_VALIDATION_EMPTY_CODE_LABEL })));
            },
        },
    ]
    : []), true), [
    {
        key: "label",
        header: COLLECT_VALIDATION_TABLE_LABEL_LABEL,
        width: "120px",
        render: function (row) { return (_jsx("span", __assign({ style: { whiteSpace: "normal", wordBreak: "break-word" } }, { children: row.values.label }))); },
    },
    {
        key: "transaction",
        header: COLLECT_VALIDATION_TABLE_TRANSACTION_LABEL,
        width: "130px",
        tag: true,
        tagTone: getTransactionTone,
    },
    {
        key: "description",
        header: COLLECT_VALIDATION_TABLE_DESCRIPTION_LABEL,
        width: "220px",
        render: function (row) { return (_jsx("span", __assign({ style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                display: "block",
            } }, { children: row.values.description }))); },
    },
    {
        key: "action",
        header: COLLECT_VALIDATION_TABLE_ACTION_LABEL,
        width: "90px",
        monospace: true,
    },
    {
        key: "actionDescription",
        header: COLLECT_VALIDATION_TABLE_ACTION_DETAIL_LABEL,
        width: "200px",
        render: function (row) { return (_jsx("span", __assign({ style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                display: "block",
            } }, { children: row.values.actionDescription }))); },
    },
    {
        key: "inCatalog",
        header: COLLECT_VALIDATION_TABLE_IN_CATALOG_LABEL,
        width: "110px",
        render: function (row) {
            return row.values.inCatalog === "true" ? (_jsx(IconCheck, { size: 16, color: "var(--mantine-color-green-6)" })) : (_jsx(IconMinus, { size: 16, color: "var(--mantine-color-gray-5)" }));
        },
    },
    {
        key: "policies",
        header: COLLECT_VALIDATION_TABLE_POLICIES_LABEL,
        width: "90px",
    },
    {
        key: "rows",
        header: COLLECT_VALIDATION_TABLE_ROWS_LABEL,
        width: "80px",
    },
], false); };
var buildKpis = function (validation) {
    if (!validation)
        return [];
    return [
        {
            value: String(validation.totalRows),
            label: COLLECT_VALIDATION_TOTAL_ROWS_LABEL,
            tone: "neutral",
        },
        {
            value: String(validation.totalPolicies),
            label: COLLECT_VALIDATION_TOTAL_POLICIES_LABEL,
            tone: "neutral",
        },
        {
            value: String(validation.totalUnknownRows),
            label: COLLECT_VALIDATION_UNKNOWN_ROWS_LABEL,
            tone: "neutral",
        },
        {
            value: String(validation.totalMissingPolicies),
            label: COLLECT_VALIDATION_MISSING_POLICIES_LABEL,
            tone: "neutral",
        },
    ];
};
export var useCollectSummaryModal = function (props) {
    var kpis = buildKpis(props.validation);
    var codeColumns = buildCodeColumns(props.showCodeColumn);
    var codeRows = props.validation
        ? props.validation.codes.map(function (row, index) { return ({
            id: "".concat(row.code, "-").concat(row.transaction, "-").concat(index),
            values: {
                code: row.code,
                label: row.label,
                transaction: getCollectTransactionLabel(row.transaction),
                description: row.description,
                action: row.action,
                actionDescription: row.actionDescription,
                inCatalog: String(row.inCatalog),
                policies: String(row.policies),
                rows: String(row.rows),
            },
        }); })
        : [];
    return {
        kpis: kpis,
        codeColumns: codeColumns,
        codeRows: codeRows,
    };
};
